





















import { Component, Vue, Prop } from 'vue-property-decorator'

import CreditCard from '@/models/credit-card'

@Component
export default class CreditCardItem extends Vue {
  @Prop() card!: CreditCard

  handleCardDelete() {
    this.$emit('on-card-delete', this.card.id)
  }
}
